import type { TOC } from '@ember/component/template-only';
import { PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import GeneralSmartInsightsFooterSmartInsights from 'lumen/components/general/smart-insights/footer-smart-insights';
import GeneralSmartInsightsListListCardSmartInsights from 'lumen/components/general/smart-insights/list/list-card-smart-insights';
import type { SmartInsightDay } from 'lumen/models';
import { SMART_INSIGHTS_HELP_ARTICLE } from 'lumen/utils/constants/smart-insights';

interface GeneralSmartInsightsListListSmartInsightsSignature {
  Args: {
    insightsSorted: SmartInsightDay[];
    selectSmartInsightsDay: (day: SmartInsightDay) => void;
  };
  Blocks: {
    afterList?: [];
  };
}

const GeneralSmartInsightsListListSmartInsights: TOC<GeneralSmartInsightsListListSmartInsightsSignature> =
  <template>
    <div
      class="flex h-full flex-col"
      data-test-id="list-smart-insights-container"
    >
      <div
        class="bg-neutral-subdued flex-grow overflow-auto px-400 pt-400 pb-[56px]"
      >
        {{#if @insightsSorted.length}}
          <div class="flex flex-col gap-700">
            {{#each @insightsSorted as |smartInsightDay|}}
              <GeneralSmartInsightsListListCardSmartInsights
                @selectSmartInsightsDay={{@selectSmartInsightsDay}}
                @smartInsightDay={{smartInsightDay}}
              />
            {{/each}}
            {{yield to="afterList"}}
          </div>
        {{else}}
          <div class="flex h-full flex-col items-center justify-center gap-400">
            <PrismMessage
              @description={{t "smart_insights.empty_state.description.small"}}
              @illustration="100x100_binoculars-intelligence"
              @title={{t "market.smart_insights.empty_column.info_text"}}
            />
            <GeneralNavigationIntercomHelpLink
              @articleLink={{SMART_INSIGHTS_HELP_ARTICLE}}
              @iconName="link-out"
              @isStandaloneLink={{true}}
              @linkText={{t "smart_insights.smart_insights_explained"}}
              @textSize="small"
              @type="text-and-icon"
            />
          </div>
        {{/if}}
      </div>

      {{#if @insightsSorted.length}}
        <div class="flex-shrink-0">
          <GeneralSmartInsightsFooterSmartInsights />
        </div>
      {{/if}}
    </div>
  </template>;

export default GeneralSmartInsightsListListSmartInsights;
